(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[494],{

/***/ 53027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22974);
/* harmony import */ var _hiredigital_ui_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90645);
/* harmony import */ var _InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13442);
/* harmony import */ var _InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var InteractiveButton = function(_param) {
    var className = _param.className, to = _param.to, href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "to",
        "href",
        "children"
    ]);
    var Component;
    if (to || href) {
        Component = _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP;
    } else {
        Component = _hiredigital_ui_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button), className),
        href: to || href || undefined
    }, props), {
        children: children
    }));
};
InteractiveButton.Type = {
    WHITE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.WHITE */ .ZP.Type.WHITE,
    BLUE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.BLUE */ .ZP.Type.BLUE,
    DARKBLUE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.DARKBLUE */ .ZP.Type.DARKBLUE,
    WHITE_BLUE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.WHITE_BLUE_OUTLINE */ .ZP.Type.WHITE_BLUE_OUTLINE,
    WHITE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.WHITE_OUTLINE */ .ZP.Type.WHITE_OUTLINE,
    BLUE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.BLUE_OUTLINE */ .ZP.Type.BLUE_OUTLINE
};
InteractiveButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    to: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (InteractiveButton);


/***/ }),

/***/ 10494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10966);
/* harmony import */ var _BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41147);
/* harmony import */ var _BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53027);





// import BlogStory from './BlogStory';


var BlogStory = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9669), __webpack_require__.e(8815), __webpack_require__.e(8579), __webpack_require__.e(3033), __webpack_require__.e(1635), __webpack_require__.e(7479)]).then(__webpack_require__.bind(__webpack_require__, 66469));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66469)
            ];
        }
    },
    ssr: false
});
var BlogStoryList = function(param) {
    var list = param.list, start = param.start, end = param.end, hideMore = param.hideMore, order = param.order, isEnterprise = param.isEnterprise, _hideTitle = param.hideTitle, hideTitle = _hideTitle === void 0 ? false : _hideTitle;
    if (order) {
        list.sort(function(a, b) {
            return order.indexOf(a.slug) - order.indexOf(b.slug);
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !hideTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().more),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    element: "h2",
                                    size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Size.SUBHEADLINE */ .Z.Size.SUBHEADLINE,
                                    color: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Color.BLACK */ .Z.Color.BLACK,
                                    style: {
                                        marginBottom: "16px"
                                    },
                                    children: "Latest Blog Posts"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    element: "h4",
                                    size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Size.SUBHEAD */ .Z.Size.SUBHEAD,
                                    color: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Color.GREY */ .Z.Color.GREY,
                                    children: "Tool and strategies modern teams need to help their companies grow."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            alignSelf: "center"
                        },
                        children: !hideMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            type: _InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Type.BLUE */ .Z.Type.BLUE,
                            title: "",
                            href: "/blog",
                            children: "View all posts"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().list), list.length > 1 ? "" : (_BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listSingle)),
                children: list.slice(start, end).map(function(story, index) {
                    var post = (story === null || story === void 0 ? void 0 : story.node) || story;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogStory, {
                        isEnterprise: isEnterprise,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), list.length > 1 ? "" : (_BlogList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemSingle)),
                        story: post
                    }, index);
                })
            })
        ]
    });
};
BlogStoryList.propTypes = {
    isEnterprise: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    list: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array),
    start: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    end: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    hideMore: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    order: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array)
};
BlogStoryList.defaultProps = {
    order: null,
    start: 0,
    end: 3,
    list: [],
    hideMore: false,
    isEnterprise: false
};
/* harmony default export */ __webpack_exports__["default"] = (BlogStoryList);


/***/ }),

/***/ 13442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"InteractiveButton_button__x3qDo"};

/***/ }),

/***/ 41147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"BlogList_list__CR95y","item":"BlogList_item__mllyo","itemSingle":"BlogList_itemSingle__n9OZp","more":"BlogList_more__Egmp5"};

/***/ })

}]);